import { render, staticRenderFns } from "./VIcon.vue?vue&type=template&id=e281c080&scoped=true"
import script from "./VIcon.vue?vue&type=script&lang=js"
export * from "./VIcon.vue?vue&type=script&lang=js"
import style0 from "./VIcon.vue?vue&type=style&index=0&id=e281c080&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e281c080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e281c080')) {
      api.createRecord('e281c080', component.options)
    } else {
      api.reload('e281c080', component.options)
    }
    module.hot.accept("./VIcon.vue?vue&type=template&id=e281c080&scoped=true", function () {
      api.rerender('e281c080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VIcon.vue"
export default component.exports